module.exports = __webpack_public_path__ + "img/t_shirt.254f01e0.svg";